import { LoadingPage } from '@/components/LoadingPage';
import { graphql } from '@/gql/codegen/gql';
import { useSuspenseQuery } from '@apollo/client';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Suspense, useEffect } from 'react';
import { useInitEmbaUserIdentifier } from './-hooks/useInitEmbaUserIdentifier';
import { Header } from './_embaUserLayout/-components/Header';
import { EmbaUserProvider } from './_embaUserLayout/-context/EmbaUser';
import { useLogout } from './_embaUserLayout/-hooks/useLogout';
import styles from './embaUserLayout.module.scss';

export const GET_CURRENT_EMBA_USER = graphql(/* GraphQL */ `
  query CurrentEmbaUser {
    currentEmbaUser{
      id
      gloplaUser {
        id
        lastName
        firstName
      }
      ...embaUserIdentifier
    }
  }
`);

export const Route = createFileRoute('/_embaUserLayout')({
  component: LayoutComponent,
});

function LayoutComponent() {
  // TODO : glopla_user queryにして useQueryにすることでここのqueryを待たずにOutlet内のqueryを実行できるようになるはずなので調整する
  const { error, data } = useSuspenseQuery(GET_CURRENT_EMBA_USER);

  const initEmbaUserIdentifier = useInitEmbaUserIdentifier(
    data.currentEmbaUser,
  );

  const {
    onLogout,
    isProcessingLogout,
    logoutMutationError,
    logoutMutationLoading,
  } = useLogout();

  if (error) {
    throw error;
  }

  if (logoutMutationError) {
    throw logoutMutationError;
  }

  useEffect(() => {
    initEmbaUserIdentifier();
  }, [initEmbaUserIdentifier]);

  if (logoutMutationLoading || isProcessingLogout) {
    return <LoadingPage />;
  }

  const userName = `${data.currentEmbaUser.gloplaUser.lastName} ${data.currentEmbaUser.gloplaUser.firstName}`;
  return (
    <div className={styles.embaUserLayout}>
      <EmbaUserProvider
        embaUserlastName={data.currentEmbaUser.gloplaUser.lastName}
      >
        <Header userName={userName} onLogout={onLogout} />
        <Suspense fallback={<LoadingPage />}>
          <Outlet />
        </Suspense>
      </EmbaUserProvider>
    </div>
  );
}
